import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import ProductsTable from '../../components/products/ProductsTable'

const Products = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <ProductsTable />
        </WrapperSection>
    );
};

export default Products;
